import { useEffect, useState } from 'react';
import { loadPecuaria, PECUARIA_CHANGED } from '../services/pecuariaService';
import { EMPTY_PECUARIA, pastureState, pecuariaMapIndicator } from './pecuariaDomain';

export default function usePecuariaMap(propertyId, enabled) {
  const [result, setResult] = useState({ data: EMPTY_PECUARIA, loading: false, error: '' });
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const changed = () => setRevision(value => value + 1);
    window.addEventListener(PECUARIA_CHANGED, changed);
    return () => window.removeEventListener(PECUARIA_CHANGED, changed);
  }, []);
  useEffect(() => {
    let active = true;
    setResult({ data: EMPTY_PECUARIA, loading: Boolean(enabled && propertyId), error: '' });
    if (!enabled || !propertyId) return undefined;
    loadPecuaria(propertyId).then(data => {
      if (active) setResult({ data, loading: false, error: '' });
    }).catch(error => { if (active) setResult({ data: EMPTY_PECUARIA, loading: false, error: error.message }); });
    return () => { active = false; };
  }, [propertyId, enabled, revision]);
  const getState = plot => {
    const id = plot?._physicalPlotId ?? (plot?._operationalPhysical ? plot.id : null);
    if (!enabled || result.loading || result.error || id == null) return null;
    const state = pastureState(id, result.data);
    return state.pasture ? state : null;
  };
  const getIndicator = plot => {
    if (!enabled || result.loading || result.error) return null;
    return pecuariaMapIndicator(plot, result.data);
  };
  return { ...result, getState, getIndicator };
}
